"use strict";

var _classlist = require('./_classlist');

var toggle = _classlist.toggle;
var contains = _classlist.contains;
// returns a binder for className of an element
// switcher makes possible to turn property value
module.exports = className;

function className(elementClassName) {
  var switcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    on: null,
    getValue: function () {
      var value = contains(this, elementClassName);
      return switcher ? value : !value;
    },
    setValue: function (value) {
      toggle(this, elementClassName, switcher ? !!value : !value);
    }
  };
}